import { Button } from '@ui-kit'

export const LandingOptionsDropdownTrigger = () => {
  return <Button variant='text-neutral' icon='icon-ellipsis-v' />
}
